"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _lodash = require("lodash");

require("./selectInfiniteScroll.scss");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Option = _antd.Select.Option;

var SelectInfiniteScroll = function SelectInfiniteScroll(_ref) {
  var loadingMore = _ref.loadingMore,
      handleFetchMore = _ref.handleFetchMore,
      _ref$showArrow = _ref.showArrow,
      showArrow = _ref$showArrow === void 0 ? false : _ref$showArrow,
      _ref$showSearch = _ref.showSearch,
      showSearch = _ref$showSearch === void 0 ? false : _ref$showSearch,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? "single" : _ref$mode,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "Select label" : _ref$placeholder,
      optionData = _ref.optionData,
      _ref$notFoundContent = _ref.notFoundContent,
      notFoundContent = _ref$notFoundContent === void 0 ? null : _ref$notFoundContent,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 160 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 28 : _ref$height,
      defaultValue = _ref.defaultValue,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$clearIcon = _ref.clearIcon,
      clearIcon = _ref$clearIcon === void 0 ? false : _ref$clearIcon,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
      _ref$allowClear = _ref.allowClear,
      allowClear = _ref$allowClear === void 0 ? false : _ref$allowClear,
      _ref$defaultOpen = _ref.defaultOpen,
      defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "medium" : _ref$size,
      onChange = _ref.onChange,
      id = _ref.id,
      value = _ref.value,
      className = _ref.className,
      name = _ref.name,
      keyName = _ref.keyName,
      onSearch = _ref.onSearch,
      filterOption = _ref.filterOption,
      popupClassName = _ref.popupClassName,
      _ref$dataPerPage = _ref.dataPerPage,
      dataPerPage = _ref$dataPerPage === void 0 ? 10 : _ref$dataPerPage,
      dropdownRender = _ref.dropdownRender;
  var onSearchFunc = (0, _react.useCallback)((0, _lodash.debounce)(function (e) {
    onSearch(e);
  }, 300), [onSearch]);

  var onClear = function onClear() {
    onSearchFunc("");
  };

  var getOptionList = function getOptionList(list) {
    return list === null || list === void 0 ? void 0 : list.map(function (item) {
      return /*#__PURE__*/_react["default"].createElement(Option, {
        key: (item === null || item === void 0 ? void 0 : item.key) || (item === null || item === void 0 ? void 0 : item.id),
        value: item === null || item === void 0 ? void 0 : item.value,
        disabled: (item === null || item === void 0 ? void 0 : item.disable) || false,
        className: item === null || item === void 0 ? void 0 : item.className
      }, (item === null || item === void 0 ? void 0 : item.icon) && /*#__PURE__*/_react["default"].createElement("img", {
        src: item === null || item === void 0 ? void 0 : item.icon
      }), (item === null || item === void 0 ? void 0 : item.label) || (item === null || item === void 0 ? void 0 : item[keyName]));
    });
  };

  var onScrollInfinite = function onScrollInfinite(e) {
    {
      if (e.target.scrollHeight - e.target.offsetHeight === e.target.scrollTop) {
        handleFetchMore(optionData === null || optionData === void 0 ? void 0 : optionData.length, dataPerPage);
      }
    }
  };

  var customDropDown = function customDropDown(menu) {
    return dropdownRender ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, dropdownRender === null || dropdownRender === void 0 ? void 0 : dropdownRender(menu), loadingMore ? /*#__PURE__*/_react["default"].createElement(_antd.Spin, {
      className: "infinite-select-spin"
    }) : null) : /*#__PURE__*/_react["default"].createElement("div", null, menu, loadingMore ? /*#__PURE__*/_react["default"].createElement(_antd.Spin, {
      className: "infinite-select-spin"
    }) : null);
  };

  var options = [];
  options = getOptionList(optionData);
  return /*#__PURE__*/_react["default"].createElement(_antd.Select, {
    "data-testid": "select-infinite-component",
    style: {
      width: width,
      height: height
    },
    mode: mode,
    size: size,
    onChange: onChange,
    onSearch: onSearchFunc,
    dropdownRender: customDropDown,
    filterOption: filterOption,
    showSearch: showSearch,
    showArrow: showArrow,
    placeholder: placeholder,
    notFoundContent: notFoundContent,
    defaultValue: defaultValue,
    disabled: disabled,
    clearIcon: clearIcon,
    autoFocus: autoFocus,
    allowClear: allowClear,
    defaultOpen: defaultOpen,
    maxTagCount: "responsive",
    listItemHeight: "2rem",
    listHeight: "8rem",
    id: id,
    value: value,
    className: "".concat(className, " iiht-ant-select"),
    name: name,
    onClear: onClear,
    virtual: false,
    getPopupContainer: function getPopupContainer() {
      return document.getElementById(popupClassName);
    },
    onPopupScroll: onScrollInfinite,
    dropdownClassName: "iiht-ant-select-dropdown"
  }, options);
};

var _default = SelectInfiniteScroll;
exports["default"] = _default;